<script>
export default {
  props: {
    options: {
      type: Object,
      required: true,
    },
    selectedPage: {
      type: {
        label: String,
      },
      required: true,
    },
  },
  methods: {
    onSelect(item) {
      this.$emit('update:selectedPage', item);
    },
  },
};
</script>

<template>
  <div class="pages-header-selector">
    <div class="buttons-menu">
      <a-dropdown-button
          class="buttons-menu-item"
          v-for="option in options"
          :key="option.key"
      >
        {{ option.title }}
        <template #overlay>
          <a-menu>
            <a-menu-item
                v-for="item in option.options"
                :key="item.value"
                @click="this.onSelect(item)"
            >
              {{ item.label }}
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown-button>
    </div>
    <h2 class="tab">Active tab: {{ selectedPage?.label }}</h2>
  </div>
</template>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/media";

.pages-header-selector {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;

  @include mediaMinMax(1025, $normal) {
    padding: 0 vw-full(20);
  }
}

.buttons-menu-item {
  margin-right: 20px;

  @include mediaMinMax(1025, $normal) {
    margin-right: vw-full(20);
  }
}

.tab {
  margin: 0;
}
</style>
